import React, { useEffect, useState } from 'react';
import GeneralProducts from './general';
import FieldCustomization from './fieldCustomization';
import Button from '../../../../../component/ui/Button';
import { getCurrentDate } from '../../../../../utils/dateUtils';
import { toast } from 'react-toastify';
import {
	getProductGeneral,
	UpdateProductGeneral,
} from '../../../../../services/settings/inventory';
import { stringToBool } from '../../../../../utils/utility';
import SettingHeaderComponent from '../../components/settingHeaderComponent';

export default function Products({ activeTab }) {
	const [tab, setTab] = useState('General');
	const [isEdit, setIsEdit] = useState(false);
	const [isCreateForm, setIsCreateForm] = useState(false);
	const [productLoader, setProductLoader] = useState({
		isLoader: true,
		isSave: false,
		isGetData: true,
		isGetDataFieldCustomisation: true,
		isSaveFieldCustomisation: true,
	});
	const [customFieldError, setCustomFieldError] = useState({});
	const [customFieldForm, setCustomFieldForm] = useState({
		label_name: '',
		data_type: '',
		status: false,
		is_mandatory: false,
	});
	const [error, setError] = useState({});
	const [generalForm, setGeneralForm] = useState();
	const [oldGeneralForm, setOldGeneralForm] = useState({
		enabled_inventory_tracking: false,
		inventory_start_date: '',
		enable_auto_purchase_order: false,
		enable_low_stock_alert: false,
		enable_composite_items: false,
		enable_auto_restock: false,
		near_expiry_threshold: '',
		auto_restock_frequency: '',
		auto_restock_interval_type: '',
		include_yet_to_receive_and_in_transit_stock: false,
	});

	const handleCustomField = () => { };

	const getGeneralDetail = async () => {
		try {
			setProductLoader((prev) => ({
				...prev,
				isLoader: true,
				isGetData: true,
			}));
			const { product_settings } = await getProductGeneral();
			if (product_settings) {
				var data = {
					enabled_inventory_tracking:
						product_settings.enabled_inventory_tracking !== null
							? stringToBool(product_settings.enabled_inventory_tracking)
							: true,
					inventory_start_date:
						product_settings.inventory_start_date !== null
							? product_settings.inventory_start_date
							: getCurrentDate(),
					enable_auto_purchase_order:
						product_settings.enable_auto_purchase_order !== null
							? stringToBool(product_settings.enable_auto_purchase_order)
							: false,
					enable_low_stock_alert:
						product_settings.enable_low_stock_alert !== null
							? stringToBool(product_settings.enable_low_stock_alert)
							: true,
					enable_composite_items:
						product_settings.enable_composite_items !== null
							? stringToBool(product_settings.enable_composite_items)
							: false,
					enabled_out_of_stock_alert:
						product_settings.enabled_out_of_stock_alert !== null
							? stringToBool(product_settings.enabled_out_of_stock_alert)
							: true,
					enable_batch_tracking:
						product_settings.enable_batch_tracking !== null
							? stringToBool(product_settings.enable_batch_tracking)
							: true,
					enable_auto_restock:
						product_settings.enable_auto_restock !== null
							? stringToBool(product_settings.enable_auto_restock)
							: false,
					auto_restock_frequency: product_settings.auto_restock_frequency || 1,
					near_expiry_threshold: product_settings.near_expiry_threshold || '',
					auto_restock_interval_type: product_settings.auto_restock_interval_type || 'Days',
					include_yet_to_receive_and_in_transit_stock:
						product_settings.include_yet_to_receive_and_in_transit_stock !== null
							? stringToBool(product_settings.include_yet_to_receive_and_in_transit_stock)
							: false,
				};
				setGeneralForm(data);
				setOldGeneralForm(data);
			}
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		} finally {
			setProductLoader((prev) => ({
				...prev,
				isLoader: false,
				isGetData: false,
			}));
		}
	};

	const getShowUndoChanged = () => {
		const hasChanged = JSON.stringify(oldGeneralForm) !== JSON.stringify(generalForm);
		setIsEdit(hasChanged);
	};

	useEffect(() => {
		if (oldGeneralForm) {
			getShowUndoChanged();
		}
	}, [generalForm]);

	function checkValidation() {
		const newError = { ...error };
		if (generalForm.enable_auto_restock) {
			if (
				!generalForm.auto_restock_frequency ||
				generalForm.auto_restock_frequency === '' ||
				generalForm.auto_restock_frequency === undefined ||
				Number(generalForm.auto_restock_frequency) < 1
			) {
				newError.auto_restock_frequency = 'Please enter greater than 0 in the field.';
			} else {
				delete newError.auto_restock_frequency;
			}
			if (
				!generalForm.auto_restock_interval_type ||
				generalForm.auto_restock_interval_type === '' ||
				generalForm.auto_restock_interval_type === undefined
			) {
				newError.auto_restock_interval_type =
					'Please select valid  auto restock interval type from the list';
			} else {
				delete newError.auto_restock_interval_type;
			}
		}

		if (generalForm.enabled_inventory_tracking) {
			if (
				!generalForm.inventory_start_date ||
				generalForm.inventory_start_date === '' ||
				generalForm.inventory_start_date === undefined ||
				(generalForm.inventory_start_date !== '' && newError.inventory_start_date)
			) {
				newError.inventory_start_date =
					newError.inventory_start_date || 'Please enter inventory start date  in the field';
			} else {
				delete newError.inventory_start_date;
			}
		}

		if (Object.keys(newError).length > 0) {
			setError(newError);
			return true;
		} else {
			return false;
		}
	}

	const handleUpdateProductGeneral = async () => {
		let isError = checkValidation();
		if (isError) {
			return toast.error('inventory product general update failed! Please fill required fields.');
		} else {
			try {
				setProductLoader((prev) => ({
					...prev,
					isLoader: true,
					isSave: true,
				}));
				setIsEdit(false);
				var body = {
					enabled_inventory_tracking: generalForm.enabled_inventory_tracking,
					inventory_start_date: generalForm.inventory_start_date,
					enable_auto_purchase_order: generalForm.enable_auto_purchase_order,
					enable_low_stock_alert: generalForm.enable_low_stock_alert,
					enable_composite_items: generalForm.enable_composite_items,
					enabled_out_of_stock_alert: generalForm.enabled_out_of_stock_alert,
					enable_batch_tracking: generalForm.enable_batch_tracking,
					enable_auto_restock: generalForm.enable_auto_restock,
					near_expiry_threshold: generalForm.near_expiry_threshold,
					include_yet_to_receive_and_in_transit_stock:
						generalForm.include_yet_to_receive_and_in_transit_stock,
					...(generalForm.enable_auto_restock && {
						auto_restock_frequency: generalForm.auto_restock_frequency,
						auto_restock_interval_type: generalForm.auto_restock_interval_type,
					}),
				};
				const res = await UpdateProductGeneral(body);
				if (res.success) {
					toast.success(res.message);
				} else {
					setIsEdit(true);
					toast.error(res.message || 'Something went wrong!');
				}
			} catch (error) {
				setIsEdit(true);
				toast.error(error.message || 'Something went wrong!');
			} finally {
				setProductLoader((prev) => ({
					...prev,
					isLoader: false,
					isSave: false,
				}));
			}
		}
	};

	useEffect(() => {
		if (tab === 'General') {
			getGeneralDetail();
		} else if (tab === 'Field Customisation') {
		}
	}, [tab]);

	return (
		<div>
			<SettingHeaderComponent
				title={activeTab}
				buttons={tab === 'Field Customisation' ? [
					{
						id: 1,
						button: 'Add New Custom Field',
						add: true,
						close: false,
						disabled: false,
						handler: () => {
							setIsCreateForm(true)
						},
						className: 'btn-primary',
					},

				] : [
					{
						id: 1,
						disabled: !isEdit || productLoader.isLoader && productLoader.isSave,
						className: 'btn-primary',
						add: false,
						close: false,
						button: 'Save',
						loader: productLoader.isLoader && productLoader.isSave,
						handler: () => {
							handleUpdateProductGeneral();
						},
					},
					isEdit && {
						id: 2,
						disabled: false,
						className: 'btn-primary',
						add: false,
						close: false,
						button: 'Undo Changed',
						handler: () => {
							setIsEdit(false);
							getGeneralDetail();
						},
					}
				].filter((button) => button !== false)}
			/>
			<div
				className="py-2 d-flex justify-content-between align-items-center"
				style={{ backgroundColor: '#DADDEC', position: 'sticky', top: 52, zIndex: 50 }}
			>
				<ul className="nav mt-2">
					{['General', 'Field Customisation'].map((item, index) => (
						<li
							key={index}
							className="nav-item"
						>
							<div
								className={`tab-link ${tab === item ? 'active' : ''} d-flex align-items-center`}
								onClick={() => {
									setTab(item);
									setIsCreateForm(false);
								}}
							>
								{item}
							</div>
						</li>
					))}
				</ul>
				{isCreateForm && (
					<div className="d-flex gap-4 align-items-center px-2">
						<div
							className="bg-blue py-2 px-4 text-white fs-5 fw-light rounded-4 cursor-pointer"
							style={{ backgroundColor: '#0066ff' }}
							onClick={() => handleCustomField()}
						>
							Save
						</div>
						<div
							className="bg-blue py-2 px-4 text-white fs-5 fw-light rounded-4 cursor-pointer"
							style={{ backgroundColor: '#555B67' }}
							onClick={() => setIsCreateForm(false)}
						>
							Cancel
						</div>
					</div>
				)}
			</div>
			{tab === 'General' ? (
				<GeneralProducts
					generalForm={generalForm}
					setGeneralForm={setGeneralForm}
					setError={setError}
					setIsEdit={setIsEdit}
					error={error}
					productLoader={productLoader}
				/>
			) : (
				<FieldCustomization
					setCustomFieldForm={setCustomFieldForm}
					customFieldForm={customFieldForm}
					customFieldError={customFieldError}
					setCustomFieldError={setCustomFieldError}
					isCreateForm={isCreateForm}
					productLoader={productLoader}
					setProductLoader={setProductLoader}
				/>
			)}
		</div>
	);
}
